import React, { FunctionComponent } from 'react';
import { Prompt } from '../../../shared/Prompt';
import { useBrandedNavigate } from '../../../../hooks/useBrandedNavigate/useBrandedNavigate';
import promptImg from '../../../../assets/Prompt/registration-abandon-prompt.png';
import { Paragraph } from '../../../shared/Paragraph';

export type GameSessionParallelProps = {
  show: boolean;
  onClose?: () => void;
  onPrimary?: () => void;
};

export const GameSessionParallel: FunctionComponent<GameSessionParallelProps> = ({ show, onClose, onPrimary }) => {
  const { navigateHome } = useBrandedNavigate();
  const onBackToLobby = (): void => navigateHome();

  return (
    <>
      <Prompt
        onClose={onClose}
        show={show}
        title="You are on more than one device"
        image={{
          src: promptImg,
          alt: 'More than one device',
        }}
        PrimaryButton={{
          onClick: onPrimary,
          text: 'Try Again',
        }}
        SecondaryButton={{
          onClick: onBackToLobby,
          text: 'Back to lobby',
        }}
      >
        <Paragraph noMargin size="sm">
          We have detected that you are playing in more than one area. If you wish to continue on this device please
          close any other game play and try again.
        </Paragraph>
      </Prompt>
    </>
  );
};
